import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import Login from "pages/Login";
import Unauthorized from "pages/Unauthorized";
import Dashboard from "pages/Dashboard";
import ProductsAndCoverage from "pages/ProductsAndCoverage";
import ManageOrders from "pages/ManageOrders";
import ManageProducts from "pages/ManageProducts";
import ManageDealers from "pages/ManageDealers";
import DealerById from "pages/DealerById";
import ManageUsers from "pages/ManageUsers";

import Sidebar from "components/Sidebar";

import ProtectedRoute from "./ProtectedRoute";
import UnprotectedRoute from "./UnprotectedRoute";
import FindOrders from "pages/FindOrders";
import ScheduleOrders from "pages/ScheduleOrders";

const RootRoutes = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/unauthorized" element={<Unauthorized />} />

        <Route element={<UnprotectedRoute />}>
          <Route path="/" element={<Login />} />
        </Route>

        <Route element={<ProtectedRoute />}>
          <Route element={<Sidebar />}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route
              path="/dealers/:dealerId/products-and-coverage"
              element={<ProductsAndCoverage />}
            />
            <Route
              path="/dealers/:dealerId/products-and-coverage/:coverageAreaId"
              element={<ProductsAndCoverage />}
            />
            <Route path="orders/manage" element={<ManageOrders />} />
            <Route path="orders/schedule" element={<ScheduleOrders />} />
            <Route path="products/manage" element={<ManageProducts />} />
            <Route path="dealers/manage" element={<ManageDealers />} />
            <Route path="dealers/find-orders" element={<FindOrders />} />
            <Route path="dealers/:id" element={<DealerById />} />
            <Route path="users/manage" element={<ManageUsers />} />
          </Route>
        </Route>

        {/*
         *
         * Criar página 404
         *
         */}
        <Route path="*" element={<span> 404 - Not Found </span>} />
      </Routes>
    </BrowserRouter>
  );
};

export default RootRoutes;
